function DownThin({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 22 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line y1="-0.75" x2="15.8705" y2="-0.75" transform="matrix(0.693109 0.720833 -0.585491 0.810679 0 1.56)" stroke=${`"${col}"`} stroke-width="1.5"/>
    <line y1="-0.75" x2="15.8705" y2="-0.75" transform="matrix(-0.693109 0.720833 0.585491 0.810679 22 1.56)" stroke=${`"${col}"`} stroke-width="1.5"/>
  </svg>
  `;

  return baseXml;
}

export default DownThin;
